function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { Song } from "./";
import { H3, P } from "../../";
const CategoryIcon = styled.img`
  border-radius: 2.4px;
  display: flex;
  height: 24px;
  margin-right: 16px;
  width: 24px;
`;
const CategoryCount = styled.div`
  background: ${props => props.theme.colors.action};
  color: #fff;
  min-width: 26px;
  height: 26px;
  border-radius: 4px;
  overflow: hidden;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;
const CategoryCountNumber = styled(P)`
  padding: 8px;
  color: #fff;
`;
const CategoryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 44px 24px 16px 24px;
  border-bottom: 1px solid rgb(230, 233, 235);
`;
const CategoryText = styled.div`
  align-items: center;
  display: inline-flex;
  min-width: 0;
  padding-right: 20px;
  width: 100%;
`;
const CategoryTitle = styled(H3)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const SongCategory = ({
  name,
  src,
  songs,
  hideHeader,
  containerRef
}) => {
  const selected = !!songs && songs.length ? songs[0].value : [];
  const count = songs.reduce((accum, song) => {
    if (selected.find(selectedSong => selectedSong === song.id)) {
      accum++;
    }

    return accum;
  }, 0);
  return React.createElement(React.Fragment, null, !hideHeader && React.createElement(CategoryContainer, {
    ref: containerRef
  }, React.createElement(CategoryText, null, React.createElement(CategoryIcon, {
    src: src
  }), React.createElement(CategoryTitle, null, name)), React.createElement(CategoryCount, {
    style: {
      background: !count && "#a6aeb2"
    }
  }, React.createElement(CategoryCountNumber, null, count))), songs.map(song => React.createElement(Song, _extends({
    key: song.id
  }, song))));
};